import { useContext } from "react";
import { AppContext } from "../App";
import { MdClose } from "react-icons/md";
import logo from "../assets/logo.png";

export default function SideBar() {
  const appContext = useContext(AppContext);

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item) {
    appContext.navTo({ item });

    if (appContext.isSideBarOpen) {
      closeSideBar();
    }
  }

  return (
    <div className="SideBar mShadow2" data-open={appContext.isSideBarOpen}>
      <div className="body mNoScrollBar">
        <h6 className="text-end" onClick={appContext.closeSideBar}>
          <MdClose size={32} style={{ cursor: "pointer" }} />
        </h6>

        <div className="logo-holder text-center">
          <div className="sidebar-brand">
            <div className="brand-lockup bg-light rounded p-3">
              <span className="brand-kicker font-bold fs-5">Nova Technologies</span>
              <span className="brand-name">Company Limited</span>
              <img className="mt-2" src={logo} style={{width:"70px", margin:"auto"}} />
            </div>
          </div>
        </div>

        <div
          className="pill"
          onClick={() => goTo("home")}
          data-active={!appContext.navItem || appContext.navItem === "home"}
        >
          <p className="text">Home</p>
        </div>

        <div
          className="pill"
          onClick={() => goTo("about_us")}
          data-active={appContext.navItem === "about_us"}
        >
          <p className="text">About Us</p>
        </div>

        <div
          className="pill"
          onClick={() => goTo("services")}
          data-active={appContext.navItem === "services"}
        >
          <p className="text">Services</p>
        </div>

        <div
          className="pill"
          onClick={() => goTo("contact_us")}
          data-active={appContext.navItem === "contact_us"}
        >
          <p className="text">Contact Us</p>
        </div>
      </div>
    </div>
  );
}
